import { type Listing } from '~/models'
import { cn } from '~/utils'

export default function ListingDescription({
  className,
  listing,
}: {
  className?: string
  listing: Listing
}) {
  const comments =
    !listing.meta.apprComments ||
    (listing.meta.apprComments && listing.meta.apprComments.includes('<p'))
      ? listing.meta.apprComments
      : `<p>${listing.meta.apprComments}</p>`
  return (
    <div
      className={cn(
        'prose mt-1 max-w-none whitespace-pre-line text-base text-foreground',
        className
      )}
      dangerouslySetInnerHTML={{
        __html: [listing.meta.description, listing.meta.highlights, comments]
          .filter((v) => v)
          .join(''),
      }}
    />
  )
}
